<template lang="pug">
  #app.app-container(v-if="settings")
    router-view
  .no-settings(v-else) No Settings
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  computed: {
    ...mapGetters([
      'settings',
      'config'
    ])
  },
  created () {
    this.$store.dispatch('LOAD_CONFIG').then(results => {
      this.$store.dispatch('LOAD_SETTINGS')
      this.$store.dispatch('LOAD_CHARTS')
      this.$store.dispatch('LOAD_NEWS')
      this.$store.dispatch('LOAD_TIPOLOGIE', results)
      this.$store.dispatch('LOAD_PDS', results)
      this.$store.dispatch('LOAD_INTERVENTI', results)
      this.$store.dispatch('LOAD_REGIONI', results)
    })
  }
}
</script>
<style lang="scss">
// ℹ️ INFO Set one or multiple variables before importing Bulma
// 🔗 https://bulma.io/documentation/overview/customize/
// 🎯 TODO Put in one file overwrite-bulma.scss?

$button-background-color: transparent;
$button-color: #ffffff;
$button-focus-color: #ffffff;
$button-focus-border-color: #ffffff;
$button-hover-color: silver;
@import "~bulma";
@import "./src/styles/tooltip";
// ℹ️ Add variables for component in /styles/vars.scss
// ℹ️ Custom global style
.main {
  padding-top: 5.5rem;
}

p {
  line-height: 1.4;
}

body {
  font: 400 16px/1 "Open Sans", sans-serif;
}

a {
  color: $link;
}

.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

h1 {
  font: 300 3em/1 "Open Sans", sans-serif;
  color: #fff;
  span {
    display: block;
  }
}

.button {
  padding-bottom: calc(0.675em - 1px);
  padding-left: 1em;
  padding-right: 1em;
  padding-top: calc(0.675em - 1px);
  border-radius: 2em;
  height: 2.85em;
  &.is-next {
    span {
      margin-left: 1.5em;
    }
  }
  &.is-prev {
    span {
      margin-right: 1.5em;
    }
  }
}

.has-background {
  background-color: #3071b4;
}

.is-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

// Trick, transform rect in path
// component IconProfit
g.indicatorsIcon rect {
  stroke: #0567b3;
}

.charts-1 .highcharts-xaxis-labels {
  display: none;
}

// Highcharts Legend
.custom-legend {
  margin-top: 2em;
  width: 100%;
  height: 44px;
  background-color: #f4f4f4;
  display: flex;
  align-items: center;
  border-radius: 20px;
  justify-content: space-evenly;
}

.custom-legend-item {
  display: flex;
  align-items: center;
  font-size: .9em;
  margin: 2.2% 0% 2.2% 0%;
  &:first-child {
    margin-left: 26px;
  }
  &:last-child {
    margin-left: 26px;
  }
}

.custom-legend-item.realizzazione {
    margin-right: 0;
}
.custom-legend-item span {
  text-transform: uppercase;
  color: #000;
}
.icon-legend {
  display: inline-block;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  margin: 0 1em 0 1.9em;
  border: 12px solid #ffffff;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAeUlEQVQ4jcXTwQ2CQBBGYUKsgBgL4Lihb+LBAoxFGEMVhB74PHhBhOyuQnzH2fwvs5mZopiBgCuO87coaNB70eGUE64xeKdL7gQHnH3y+Iuk3auTO6ocySUmKSOeMbG24Rd+msQW4aXxpW2j9VXOuofvj2kiCbilhp+lPXag1639swAAAABJRU5ErkJggg==');
}
.pianificazione + .icon-legend {
  background-color: #4F81BC;
}
.concertazione + .icon-legend {
  background-color: #A8BCD4;
}
.autorizzazione + .icon-legend {
  background-color: #579DBE;
}
.realizzazione + .icon-legend {
  background-color: #2B4D76;
}
.concluso + .icon-legend {
  background-color: #579DBE;
}
// Spider
.highcharts-axis-labels > span {
  text-transform: uppercase;
  font-weight: bold;
}
.highcharts-tooltip-box {
  fill: #7397a9;
  fill-opacity: 0.4;
  stroke-width: 0;
}
.highcharts-tooltip text {
  color: #ffffff !important;
  fill: #ffffff !important;
  text-shadow: 0 0 3px #7397a9;
}
// MAPPA UI
.esri-zoom > div {
  padding: .4em;
}
</style>



// WEBPACK FOOTER //
// src/App.vue